module.exports = __webpack_public_path__ + "images/file_icons_v2/ai-f46ce917c93ff54fe54bd9188e7655a7.svg";